import { constants } from 'lib_ui-services';

export default {
    verb: 'didUpdate',
    namespace: 'metaui',
    relation: 'captionOverrides',
    description: 'Show Caption Overrides notification',
    logic: showNotification
};

function showNotification({ dispatch }) {
    dispatch(
        {
            message: 'Caption Override values saved.',
            addToList: false,
            isError: false, //todo: gl2025 remove
            variant: 'success',
            type: constants.notificationTypes.TOAST
        },
        {
            verb: 'pop',
            namespace: 'application',
            relation: 'notification'
        }
    );
}
